// src/components/organisms/Profile/ProfileSubmissionsSection.js

import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import SubmissionCard from "../../molecules/ChallengeSubmission/SubmissionCard";

const ProfileSubmissionsSection = ({ profileId, firstName, submissions, theme,isChallenge=true }) => {

  return (
    <Box
      sx={{
        backgroundColor: theme.colors.lightBlue,
        borderRadius: "25px",
        // padding: 4,
        paddingBottom: 0,
        mt: 4, // Add margin-top for spacing
      }}
    >
      {/* Full-width Row Above the Grid */}
      {isChallenge ?
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 4,
        }}
      >

        {/* User's First Name and Link */}
        <Box sx={{ display: "flex" }}>
          
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontFamily: "basic-sans",
                fontWeight: "normal",
                marginRight: 2,
              }}
            >
                {firstName && firstName.trim() ? `${firstName}'s Submissions to Challenges` : "My Submissions to Challenges"}
            </Typography>
        </Box>
      </Box>
      :
        <Typography variant="h4" gutterBottom sx={{ fontFamily: "basic-sans" }}>
          My Sales
        </Typography>
}

      {/* Grid of Submission Cards */}
      <Grid container spacing={4}>
        {submissions && submissions.length > 0  ?
        submissions.map((submission) => (
          <Grid item xs={12} sm={6} md={4} key={submission.id}>
            <SubmissionCard submission={submission} />
          </Grid>
        ))
        :
          <Box
            sx={{
              display: "flex",
              marginLeft:4,
            }}
          >
            <Typography gutterBottom sx={{ fontFamily: "basic-sans", }}>
              No record found
            </Typography>
          </Box>
      }
      </Grid>
    </Box>
  );
};

export default ProfileSubmissionsSection;

